/* Inspector layout; controls come from ui.module.css. */

.panel,
.sheet {
  z-index: var(--z-chrome);
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: var(--space-3) 14px 14px;
  font-size: var(--text-md);
  overflow: auto;
}

.panel {
  position: absolute;
  top: var(--chrome-inset);
  right: var(--chrome-inset);
  width: 272px;
  max-height: calc(100% - var(--chrome-inset) * 2 - 64px);
}

.sheet {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: calc(66px + var(--safe-bottom));
  max-height: 45vh;
  border-radius: var(--radius-lg);
}

.header {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.kind {
  font-size: var(--text-xs);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ink-faint);
}

.title {
  font-weight: 600;
  font-size: 14px;
  border: 1px solid transparent;
  border-radius: var(--radius);
  padding: 2px var(--space-1);
  margin-left: calc(var(--space-1) * -1);
  background: transparent;
  color: var(--ink);
}

.title:hover,
.title:focus {
  border-color: var(--chrome-edge);
  background: var(--surface);
}

.section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sectionTitle {
  margin: 0;
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--ink-soft);
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 10px;
}

.row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.row:has(.mono),
.row:has(.idChip) {
  grid-column: 1 / -1;
}

.label {
  flex: none;
  width: 56px;
  color: var(--ink-faint);
  font-size: var(--text-sm);
}

.value {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  min-width: 0;
  flex: 1;
}

.grow {
  flex: 1;
  min-width: 0;
}

.unit {
  color: var(--ink-faint);
  font-size: var(--text-sm);
}

.mono {
  font-family: var(--font-mono);
  font-size: var(--text-sm);
  color: var(--ink);
  overflow-wrap: anywhere;
}

.idChip {
  max-width: 100%;
}

/* Inspector fields: bordered, compact, monospace numbers. */
.field {
  flex: 1;
  min-width: 0;
  min-height: 28px;
  padding: 0 var(--space-2);
  border: 1px solid var(--chrome-edge);
  border-radius: var(--radius);
  background: var(--surface);
  font-family: var(--font-mono);
  font-size: 12px;
}

.field:hover {
  border-color: var(--ink-faint);
}

.field:focus-within {
  border-color: var(--focus);
  box-shadow: 0 0 0 2px var(--focus-soft);
}

.field input {
  padding: 0;
}

.field input:focus-visible {
  box-shadow: none;
}

.grow select {
  padding: 4px 24px 4px 8px;
  border: 1px solid var(--chrome-edge);
  border-radius: var(--radius);
  font-size: 13px;
}

.buttons {
  display: flex;
  gap: 6px;
  margin-top: var(--space-1);
}

.hint {
  margin: var(--space-1) 0 0;
  color: var(--ink-faint);
  font-size: var(--text-sm);
  font-style: italic;
}

@media (max-width: 1023px) {
  .panel {
    width: 240px;
  }
}
